import dayjs from 'dayjs'

const EXPECTED_YEAR_LENGTH = 4

export const formatYearToYYYY = (dateString) => {
  const dateElements = dateString.split('-')
  const yearString = dateElements[0]
  const yearStringLength = yearString.length

  const formattedYearString =
    yearStringLength === EXPECTED_YEAR_LENGTH
      ? yearString
      : yearString.padStart(EXPECTED_YEAR_LENGTH, '0')

  dateElements[0] = formattedYearString

  return dateElements.join('-')
}

export const dtFormat = (dtString = '', format = 'YYYY-MM-DD') => {
  return dtString ? formatYearToYYYY(dayjs(dtString).format(format)) : ''
}

export const getDateAfterBusinessDays = (
  businessDays,
  startDate = new Date()
) => {
  let addedDays = 0
  let currentDate = new Date(startDate)
  currentDate.setUTCHours(0, 0, 0, 0)

  while (addedDays < businessDays) {
    currentDate.setDate(currentDate.getDate() + 1)

    if (!isWeekend(currentDate) && !isHoliday(currentDate)) {
      addedDays++
    }
  }

  return currentDate
}

export const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6

export const isHoliday = (date) => {
  const year = date.getFullYear()

  // Italian public holidays
  const holidays = [
    new Date(year, 0, 1), // Capodanno
    new Date(year, 0, 6), // Epifania
    new Date(year, 3, 25), // Festa della Liberazione (25 aprile)
    new Date(year, 4, 1), // Festa del Lavoro (1 maggio)
    new Date(year, 5, 2), // Festa della Repubblica (2 giugno)
    new Date(year, 7, 15), // Ferragosto
    new Date(year, 9, 4), // San Francesco
    new Date(year, 10, 1), // Tutti i Santi
    new Date(year, 11, 8), // Immacolata Concezione
    new Date(year, 11, 25), // Natale
    new Date(year, 11, 26) // Santo Stefano
  ]

  return holidays.some(
    (holiday) =>
      holiday.getFullYear() === date.getFullYear() &&
      holiday.getMonth() === date.getMonth() &&
      holiday.getDate() === date.getDate()
  )
}
